import type { VehicleDef } from '@/systems/VehicleState';

export type { VehicleDef, VehicleKind } from '@/systems/VehicleState';

/** Range (px) within which the player can mount a vehicle (checked by StageScene). */
export const VEHICLE_MOUNT_RANGE = 80;

/** Bermondsey Docks forklift — high HP, wide slow ram. Stage 3 prop. */
export const BERMONDSEY_FORKLIFT: VehicleDef = {
  kind: 'forklift',
  maxHp: 40,
  ramDamage: 20,
  ramKnockback: 60,
  ramHitstun: 30,
  ramRadius: 80,
  speedMult: 1.2,
};

/** Downed biker's bike — lighter HP, fast movement, narrower ram hitbox.
 * Spawned as a mountable prop by the Enemy adapter when wantsKnockOff fires
 * (TODO(MY-1800): wire in Enemy.ts BikerAI adapter). */
export const OUTRIDER_BIKE: VehicleDef = {
  kind: 'bike',
  maxHp: 30,
  ramDamage: 25,
  ramKnockback: 50,
  ramHitstun: 24,
  ramRadius: 60,
  speedMult: 2.0,
};

/** Northern Line maintenance trolley — medium HP, moderate ram. Stage 4 themed mount. */
export const TUBE_TROLLEY: VehicleDef = {
  kind: 'tube-trolley',
  maxHp: 35,
  ramDamage: 18,
  ramKnockback: 55,
  ramHitstun: 28,
  ramRadius: 70,
  speedMult: 1.4,
};

/** Camden market delivery scooter — low HP, fast, narrow hitbox. Stage 1 themed mount. */
export const MARKET_SCOOTER: VehicleDef = {
  kind: 'market-scooter',
  maxHp: 25,
  ramDamage: 22,
  ramKnockback: 45,
  ramHitstun: 20,
  ramRadius: 50,
  speedMult: 2.2,
};

/** Downed snatch-crew moped — lighter than the outrider bike; floor hazard/obstacle.
 * Spawned by the Enemy adapter when wantsKnockOff fires (MY-1910). */
export const SNATCH_MOPED: VehicleDef = {
  kind: 'moped',
  maxHp: 20,
  ramDamage: 18,
  ramKnockback: 40,
  ramHitstun: 18,
  ramRadius: 55,
  speedMult: 2.2,
};

export const VEHICLES: Record<string, VehicleDef> = {
  forklift: BERMONDSEY_FORKLIFT,
  bike: OUTRIDER_BIKE,
  'tube-trolley': TUBE_TROLLEY,
  'market-scooter': MARKET_SCOOTER,
};

/**
 * Resolve the rideable mount definition for a stage given its rideableId.
 * Returns undefined when rideableId is absent or unrecognised (no crash).
 */
export function getStageRideable(rideableId: string | undefined): VehicleDef | undefined {
  if (!rideableId) return undefined;
  return VEHICLES[rideableId];
}
